<template>
  <v-dialog v-model="display" width="830" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline grey lighten-3" primary-title>
        <v-layout>
          <v-flex grow>
            New Lease
          </v-flex>
          <v-spacer />
          <v-btn flat icon class="align--right" @click.stop="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <LeaseInfo ref="info" :lease.sync="lease" />
      </v-card-text>
      <v-card-actions class="px-4 py-3">
        <v-btn block color="primary" @click="add()">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import LeaseInfo from '@/components/houselist/details/LeaseInfo'

export default {
  name: 'DetailsLeaseAdd',
  components: { LeaseInfo },
  data() {
    return {
      display: true,
      lease: {
        checkin_date: '',
        checkout_date: '',
        first_payment_date: '',
        rent: '',
        pay_frequency: '',
        mgmt_fee_type: '',
        mgmt_fee_rate: '',
        mgmt_fee_fixed: '',
        // house_id: ''
      }
    }
  },
  methods: {
    ...mapActions({
      addLease: 'HouseList/Lease/addLease'
    }),
    add() {
      if (this.$refs.info.$refs.addLease.validate()) {
        this.lease.house_id = this.$route.params.houseId

        if (this.lease.mgmt_fee_type === 2) {
          this.lease.mgmt_fee_fixed = this.lease.mgmt_fee_rate
          this.lease.mgmt_fee_rate = ''
        } else {
          this.lease.mgmt_fee_fixed = ''
        }

        this.addLease(this.lease)
        this.display = false
      }
    },
    close() {
      this.display = false
      this.$router.go(-1)
    }
  }
}
</script>
